import { onBeforeUnmount, onMounted } from "#imports";
export default function(cb) {
  let raf = null;
  const loop = (time) => {
    cb(time);
    raf = window.requestAnimationFrame(loop);
  };
  onMounted(() => {
    raf = window.requestAnimationFrame(loop);
  });
  onBeforeUnmount(() => {
    window.cancelAnimationFrame(raf);
  });
}
